export { pluralize as default, pluralizeWord } from "./pluralizeFunc";
